import Logo from "../../assets/images/logo2-removebg-preview.png";
import BeatLoader from "react-spinners/BeatLoader"

const BouncingLoading = () => {
    return (
        <div
            className="h-100 d-flex items-center justify-center z-20 h-100 justify-content-center items-center text-center"
            style={{backgroundColor: 'transparent'}}>
            <div className="w-auto my-auto">
                <BeatLoader color="black" className="" size={30}/>
            </div>
            <img src={Logo} alt="Logo" className="mx-3 my-auto" style={{height: '100px', width: '100px'}}/>
        </div>
    
    )
}

export default BouncingLoading;
